// Dependencies
import React, { FunctionComponent, useRef } from "react";

// Styles
import { Container, Label, RadioInput } from "./styles";

// Types
type WebpRadioInputProps = {
    name: string;
    label?: string;
    inputId?: string;
    value: string;
    checked: boolean;
    disabled?: boolean;
    onRadioGroupOptionCheck: (detail: { checked: boolean; value: string }) => void;
};

export const WebpRadioInput: FunctionComponent<WebpRadioInputProps> = ({
    checked,
    name,
    value,
    disabled,
    inputId,
    label,
    onRadioGroupOptionCheck
}) => {
    const id = !!inputId ? inputId : name;

    const containerRef = useRef<HTMLDivElement>(null);

    const inputRef = useRef<HTMLInputElement>(null);

    const setFocus = () => {
        if (!!containerRef.current) {
            containerRef.current.focus();
        }
    };

    const onClick = (ev: any) => {
        ev.preventDefault();

        if (disabled) return;

        setFocus();

        onRadioGroupOptionCheck({ value, checked: !checked });
    };

    return (
        <Container
            ref={containerRef}
            role="radio"
            onClick={onClick}
            aria-labelledby={!!label ? label : ""}
            aria-checked={checked}
            aria-hidden={!!disabled ? true : !disabled}
        >
            <div className="wrapper-input">
                <RadioInput
                    aria-checked={checked}
                    disabled={disabled}
                    checked={checked}
                    onFocus={setFocus}
                    id={id}
                    type="radio"
                    ref={inputRef}
                    name={name}
                />

                <Label isDisabled={!!disabled} isChecked={checked} htmlFor={id} type="input" />
            </div>

            <Label isDisabled={!!disabled} isChecked={checked} htmlFor={id} type="container">
                {label && <span>{label}</span>}
            </Label>
        </Container>
    );
};
